import { useNavigate } from "react-router-dom";

export const ErrorHandler = (e, navigate) => {
    console.log(e);

    if (e.status === 401) {
        localStorage.setItem("isLoged", JSON.stringify(false));
        navigate("/");
    }

    if (e?.data?.message) {
        return alert(e.data.message);
    }
};
